// eslint-disable-next-line @nx/enforce-module-boundaries
import { SmartEditConfig } from '@spartacus/smartedit';

// TODO: allowOrigin нужно как-то красиво прокинуть в env
export const defaultSmartEditConfig: SmartEditConfig = {
  smartEdit: {
    storefrontPreviewRoute: 'cx-preview',
    allowOrigin: `localhost:9002,
       *.co34y44o-rosa1-d1-public.model-t.cc.commerce.ondemand.com:443,
       *.co34y44o-rosa1-s1-public.model-t.cc.commerce.ondemand.com:443,
       *.co34y44o-rosa1-p1-public.model-t.cc.commerce.ondemand.com:443,
       *.sdvor.com:443,
       *.itlabs.io:443,
       *.sdvor-com.itlabs.io:443,
       *.stage.sdvor-com.itlabs.io:443,
       *.dev.sdvor-com.itlabs.io:443`,
  },
};
